export var validation = {
  EMAIL_REGEX: new RegExp(/^[a-zA-Z0-9_.\-+](?:[a-z0-9!#$%&'*+/=?^_`{|}~-]*(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i),
  VALID_URL: new RegExp(/^((https?):\/\/)?([a-z\u00a1-\uffff0-9]+([.-][a-z\u00a1-\uffff0-9]+)*\.[a-z\u00a1-\uffff]{2,})(:\d{2,5})?([/?#]\S*)?$/i)
};